<template>
  <div class="struct_moni">
    <div class="top">
      <div class="top__img">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/moni_icon.png" width="100%" />
      </div>
      <div class="top__large">工程智能监测</div>
      <div class="top__small" style="margin-top:20px;">应用智能传感器、无线通信网络、大数据云计算、人工智能等新型监测技术，为大型复杂工程在全寿命周期的质量与安全提供及时可靠的技术保障</div>
    </div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/business">业务介绍</BreadcrumbItem>
      <BreadcrumbItem>工程智能监测</BreadcrumbItem>
    </Breadcrumb>
    <div class="content">
      <div v-for="item in structList" :key="item.id" class="contentBox">
        <!-- <div class="title">{{item.title}}</div>  -->
        <img :src="item.image" alt="" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'struct_moni',
  data() {
    return {
      projectList: [
        '江门市船厂跨江桥梁施工监控、运营过程健康监测服务',
        '广州市鹤洞大桥健康监测中山市地方公路桥梁健康监测',
        '广州市新光大桥健康监测',
        '佛山市顺德水道特大桥结构健康监测',
        '佛山市华阳特大桥运营期结构健康监测系统实施',
        '佛山市龙湾大桥长期健康监测系统实施',
        '金融城站综合交通枢纽PPP项目钢屋盖施工第三方监测',
        '大疆天空之城结构施工监控与运营健康监测服务',
        '广州体育馆钢结构屋架监测',
        '汇德大厦1#楼主体结构监测'
      ],
      structList: [
        {
          id: 'struct1',
          title: '结构施工监控',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_moni1.png'
        },
        {
          id: 'struct2',
          title: '结构健康监测',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_moni2.png'
        },
        {
          id: 'struct3',
          title: '结构检测鉴定',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_moni3.png'
        },
      ]
    }
  },
  created() {
    this.$emit('changeProduce','struct_moni')
  },
  mounted () {
    document.body.scrollIntoView()
  }
}
</script>
<style lang="less" scoped>
.struct_moni {
  .top {
    width: 100%;
    height: 280px;
    background: url('https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_moni_banner.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #fff;
    &__img {
      width: 71px;
      height: 66px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 16px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 64px;
    .contentBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0;
      .title {
        margin: 48px 0 50px;
        position: relative;
        font-size: 30px;
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 8px;
        background-color: #FAAD14;
      }
      img{
        width: 100%;
        margin: 20px 0;
      }
    }
  }
}
</style>
